export default "/cars-for-sale/sitemap/:sitemapPageId?";